import React from 'react'
import InfiniteScroll from 'react-bidirectional-infinite-scroll'
import { Spin } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'
import { Container, Table, HeaderRow, StatusCell, Row, Cell } from './styled-components'

export default function PriceBlocksTable({
  isLoading,
  priceBlocks,
  loadingDirection,
  pageSize,
  total,
  handleScroll,
  size,
  tableRef,
  containerRef,
}) {
  return (
    <Container>
      <InfiniteScroll
        onReachBottom={() => handleScroll('DOWN')}
        onReachTop={() => handleScroll('UP')}
        ref={containerRef}
      >
        <Table ref={tableRef} size={size}>
          <thead>
            <HeaderRow size={size}>
              <th>Price Block</th>
              <th>Local Time (MM/DD/YYYY)</th>
              <th>UTC Time (MM/DD/YYYY)</th>
              <th>CNR Value</th>
              <th>Status</th>
            </HeaderRow>
          </thead>
          <tbody>
            {!isLoading && !priceBlocks.length ? (
              <tr>
                <StatusCell colSpan={4}>No data</StatusCell>
              </tr>
            ) : null}
            {isLoading && (loadingDirection === 'UP' || loadingDirection === 'NAVIGATE') ? (
              <tr>
                <StatusCell colSpan={4}>
                  <Spin />
                </StatusCell>
              </tr>
            ) : null}
            {!isLoading && priceBlocks.length && loadingDirection === 'UP' && total < pageSize ? (
              <tr>
                <StatusCell colSpan={4}>Finished</StatusCell>
              </tr>
            ) : null}
            {priceBlocks?.map((item) => (
              <Row active={item.status === 'ACTIVE'} size={size} key={item.block}>
                <Cell>{item.block}</Cell>
                <Cell>{item.date}</Cell>
                <Cell>{item.utc}</Cell>
                <Cell>${item.price}</Cell>
                <Cell>
                  <CheckCircleFilled
                    style={{
                      color:
                        item.status === 'COMPLETED' || item.status === 'SPLIT'
                          ? '#52c41a'
                          : item.status === 'ACTIVE'
                          ? '#1890ff'
                          : '#cccccc',
                    }}
                  />{' '}
                  {size === 'middle' ? (item.status === 'SPLIT' ? '100x split' : item.status) : null}
                </Cell>
              </Row>
            ))}
            {isLoading && loadingDirection === 'DOWN' ? (
              <tr>
                <StatusCell colSpan={4}>
                  <Spin />
                </StatusCell>
              </tr>
            ) : null}
            {!isLoading && priceBlocks.length && loadingDirection === 'DOWN' && total < pageSize ? (
              <tr>
                <StatusCell colSpan={4}>Finished</StatusCell>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </InfiniteScroll>
    </Container>
  )
}
